import React from 'react';

export default function Footer(props) {
	return (
		<div className="bottom-row">
			<hr />
			<p>Special thanks to Gueverly Mendez for inspiring this project by commenting that a Python script I'd written "looks like Chinese."</p>
			<p>Made with {"<3"} by Parth Sarin.</p>
		</div>
	);
}